import type { CellData as RootCellData } from '../types';

export const kind = 'transaction-id-cell' as const;

export interface TransactionIdCellData
  extends RootCellData<typeof kind, string | null> {}
